
import type { PaymentMethodIdentifier } from '@/checkout/components/SelectPaymentMethod.vue'
import type { WalletType } from '@/checkout/helpers/wallets'
import StripeWalletPayment from '@/checkout/stripe/StripeWalletPayment'
import MobileCartButton from '@/components/elements/MobileCartButton.vue'
import Price from '@/components/elements/Price.vue'
import { closeCartModal } from '@/helpers/ModalDialogs'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import PayButton from './PayButton.vue'

@Component({
  components: { MobileCartButton, Price, PayButton },
  computed: mapGetters({
    paymentDueByCreditCard: 'Cart/paymentDueByCreditCard',
  }),
})
export default class CheckoutMobileFooter extends Vue {
  @Prop({ default: false })
  isCheckout: boolean

  @Prop({ default: false })
  submitDisabled: boolean

  @Prop({ default: false })
  submitting: boolean

  @Prop()
  supportedWallet: WalletType

  @Prop()
  selectedPaymentType: PaymentMethodIdentifier

  @Prop()
  wallet: StripeWalletPayment | null

  get hideCartAndTotal() {
    return this.$store.state.Cart.redeemMembership && this.$store.getters['Cart/paymentDueByCreditCard'] === 0
  }

  onSubmit() {
    closeCartModal()
    if (this.isCheckout) {
      this.$emit('submit')
    } else {
      this.$router.push('/checkout')
    }
  }
}
